import React, {Component} from 'react';
import PropTypes from 'prop-types';

class SinglePersonSvg extends Component {

  render() {
    const width = this.props.width || 50;
    const height = width * 2;

    const value = this.props.value || 0;
    const total = this.props.total || 1;

    const clipOffset = height - height * value / total;

    return (
      <div ref="wrapper" className="SinglePersonSvg" style={{height: height, width: width}}>
        <div className="background" style={{height: height, width: width}}>
          <svg width={width} height={height} viewBox="0 0 250 500">
            <path d="M223.8,310.8V185.2c0-27.5-22.4-49.9-49.9-49.9h-24.5l15.8-16.8c9.7-10.3,15-23.7,15-37.8
            c0-30.5-24.8-55.3-55.3-55.3S69.7,50.2,69.7,80.7c0,14,5.3,27.5,15,37.8l15.8,16.8H76
            c-27.5,0-49.9,22.4-49.9,49.9v123.6l0,0.2l0,0.2l0,1.3l0,0.2c0,0,0,0.1,0,0.2l0.2,0.8l0.1,0.8
            c1.1,11.5,11,20.6,22.4,20.6c2.3,0,4.8-0.5,7.5-1.5l13.4-4.8v119.6c0,15.5,12.6,28.1,28.1,28.1
            c7.6,0,14.7-3,20.1-8.5l7.2-7.3l7.2,7.3c5.4,5.5,12.5,8.5,20.1,8.5c15.5,0,28.1-12.6,28.1-28.1
            V326.8l13.4,4.8c2.7,1,5.2,1.5,7.5,1.5c11.9,0,22-9.6,22.7-21.5l0-0.2c0,0,0-0.1,0-0.1L223.8,310.8z"/>
          </svg>
        </div>
        <div className="fill" style={{width: width, top: clipOffset}}>
          <svg width={width} height={height} viewBox="0 0 250 500">
            <path d="M223.8,310.8V185.2c0-27.5-22.4-49.9-49.9-49.9h-24.5l15.8-16.8c9.7-10.3,15-23.7,15-37.8
            c0-30.5-24.8-55.3-55.3-55.3S69.7,50.2,69.7,80.7c0,14,5.3,27.5,15,37.8l15.8,16.8H76
            c-27.5,0-49.9,22.4-49.9,49.9v123.6l0,0.2l0,0.2l0,1.3l0,0.2c0,0,0,0.1,0,0.2l0.2,0.8l0.1,0.8
            c1.1,11.5,11,20.6,22.4,20.6c2.3,0,4.8-0.5,7.5-1.5l13.4-4.8v119.6c0,15.5,12.6,28.1,28.1,28.1
            c7.6,0,14.7-3,20.1-8.5l7.2-7.3l7.2,7.3c5.4,5.5,12.5,8.5,20.1,8.5c15.5,0,28.1-12.6,28.1-28.1
            V326.8l13.4,4.8c2.7,1,5.2,1.5,7.5,1.5c11.9,0,22-9.6,22.7-21.5l0-0.2c0,0,0-0.1,0-0.1L223.8,310.8z"/>
          </svg>
        </div>
        <div className="outline" style={{height: height, width: width}}>
          <svg width={width} height={height} viewBox="0 0 250 500">
            <path d="M233.8,310.4c0-0.3,0-0.7,0-1V185.2c0-32.9-27-59.9-59.9-59.9h-1.4c11-11.7,17.8-27.4,17.8-44.6
            c0-35.9-29.4-65.3-65.3-65.3S59.7,44.8,59.7,80.7c0,17.2,6.8,32.9,17.8,44.6H76c-32.9,0-59.9,27-59.9,59.9
            v123.1c0,0.5,0,0.9,0,1.4v0.7c0,1,0.1,2.1,0.3,3.1c1.6,16.5,15.5,29.6,32.3,29.6c3.8,0,7.4-0.8,10.9-2v105.4
            c0,20.9,17.2,38.1,38.1,38.1c10.6,0,20.3-4.5,27.2-11.6c6.9,7.1,16.6,11.6,27.2,11.6c20.9,0,38.1-17.2,38.1-38.1
            V341c3.4,1.2,7.1,2,10.9,2c17.3,0,31.7-13.9,32.7-31C233.9,311.6,233.9,311,233.8,310.4z
            M125,37.2c24.2,0,43.5,19.3,43.5,43.5c0,24.2-19.3,43.5-43.5,43.5s-43.5-19.3-43.5-43.5
            C81.5,56.5,100.8,37.2,125,37.2z M212.1,308.7c0,0.3,0,0.7,0,1v0.7c0,0.3,0,0.7,0,1c-0.5,5.7-5.1,9.9-10.9,9.9
            c-6.2,0-10.9-4.7-10.9-10.9v-1c0-0.3,0-0.7,0-1v-95.9h-21.8v95.9c0,0.5,0,0.9,0,1.4v136.7
            c0,9.1-7.2,16.3-16.3,16.3c-8.6,0-15.5-6.3-16.3-14.6c0-0.6,0-1.1,0-1.7V321.3h-21.8v126.9
            c-0.8,8.3-7.7,14.6-16.3,14.6c-9.1,0-16.3-7.2-16.3-16.3v-234H59.7v96.3c0,0.3,0,0.7,0,1v0.7
            c0,6.2-4.7,10.9-10.9,10.9c-5.9,0-10.5-4.4-10.9-10.2c0-0.2,0-0.5,0-0.7c0.1-0.7,0.1-1.4,0-2
            V185.2c0-21.1,17-38.1,38.1-38.1h98c21.1,0,38.1,17,38.1,38.1V308.7z"/>
          </svg>
        </div>
      </div>
    );
  }
}

SinglePersonSvg.propTypes = {
  value: PropTypes.number,
  total: PropTypes.number
};

export default SinglePersonSvg;



// WEBPACK FOOTER //
// ./src/charts/PersonPictograph/SinglePersonSvg.js